import { getErrorPayload } from '@application/common/helpers/api-helper';
import InternalCompanyApi from '@infrastructure/internalcompany-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const getInternalCompaniesAsync = createAsyncThunk('internalCompany/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await InternalCompanyApi.getAll();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createOrUpdateInternalCompanyAsync = createAsyncThunk('internalCompany/createOrUpdate', async (payload, { rejectWithValue }) => {
    try {
        const response = await InternalCompanyApi.createOrUpdate(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
